import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    conversations: [],
    listings: [],
    phoneCallsByGuid: {},
    startDate: '',
    endDate: '',
    listingByListingId: {},
    nextStartDateString: '',
    currentStartDateString: '',
    queryFullConversationCount: 0,
    pageConversationCount: 0,
});

const allLeads = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.LEAD_ALL_LEADS_SUCCESS: {
            const { appendToAllLeads, leadsAllModel } = payload;
            let { conversations } = leadsAllModel;

            if (appendToAllLeads) {
                conversations = [...state.conversations, ...conversations];
            }

            return assign({}, state, leadsAllModel, { conversations });
        }
        case DispatchConstants.LEAD_ALL_LEADS_FAIL:
            return state;

        default:
            return state;
    }
};

export default allLeads;
